import { useEffect } from "react";
import styled from "styled-components";
import { message, Switch, Typography } from "antd";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { getPidgeStatus, updatePidgeStatus } from "store/pidge/pidgeSlice";

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

const ToggleLabel = styled(Typography.Text)`
  margin: 0;
  font-size: 0.875rem;
`;

const MESSAGE_KEY = "pidge-toggle-status";

export const PidgeToggle = () => {
  const dispatch = useAppDispatch();
  const { isEnabled, status, error } = useAppSelector((state) => state.pidge);
  const loading = status === "loading";
  const updating = status === "saving";

  useEffect(() => {
    dispatch(getPidgeStatus());
  }, [dispatch]);

  useEffect(() => {
    if (status === "error") {
      message.error({
        content: error || "Failed to process Pidge request",
        key: MESSAGE_KEY,
      });
    }
  }, [error, status]);

  const onToggle = async (checked: boolean) => {
    try {
      await dispatch(updatePidgeStatus(checked)).unwrap();
      message.success({
        content: `Pidge ${checked ? "enabled" : "disabled"}`,
        key: MESSAGE_KEY,
      });
    } catch (_) {
      // Error toast is handled from slice status changes.
    }
  };

  return (
    <ToggleContainer>
      <ToggleLabel>{`Pidge ${isEnabled ? "Enabled" : "Disabled"}`}</ToggleLabel>
      <Switch checked={isEnabled} loading={loading || updating} onChange={onToggle} />
    </ToggleContainer>
  );
};
